import { render, staticRenderFns } from "./luckDraw.vue?vue&type=template&id=0d10163f&scoped=true&"
import script from "./luckDraw.vue?vue&type=script&lang=js&"
export * from "./luckDraw.vue?vue&type=script&lang=js&"
import style0 from "./luckDraw.vue?vue&type=style&index=0&id=0d10163f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d10163f",
  null
  
)

export default component.exports